"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.a = getWindow;
exports.g = getDocument;
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
function isObject(e) {
  return null !== e && "object" == _typeof(e) && "constructor" in e && e.constructor === Object;
}
function extend(e, t) {
  void 0 === e && (e = {}), void 0 === t && (t = {}), Object.keys(t).forEach(function (n) {
    void 0 === e[n] ? e[n] = t[n] : isObject(t[n]) && isObject(e[n]) && Object.keys(t[n]).length > 0 && extend(e[n], t[n]);
  });
}
var ssrDocument = {
  body: {},
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  activeElement: {
    blur: function blur() {},
    nodeName: ""
  },
  querySelector: function querySelector() {
    return null;
  },
  querySelectorAll: function querySelectorAll() {
    return [];
  },
  getElementById: function getElementById() {
    return null;
  },
  createEvent: function createEvent() {
    return {
      initEvent: function initEvent() {}
    };
  },
  createElement: function createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function setAttribute() {},
      getElementsByTagName: function getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS: function createElementNS() {
    return {};
  },
  importNode: function importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function getDocument() {
  var e = "undefined" != typeof document ? document : {};
  return extend(e, ssrDocument), e;
}
var ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState: function replaceState() {},
    pushState: function pushState() {},
    go: function go() {},
    back: function back() {}
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  getComputedStyle: function getComputedStyle() {
    return {
      getPropertyValue: function getPropertyValue() {
        return "";
      }
    };
  },
  Image: function Image() {},
  Date: function Date() {},
  screen: {},
  setTimeout: function setTimeout() {},
  clearTimeout: function clearTimeout() {},
  matchMedia: function matchMedia() {
    return {};
  },
  requestAnimationFrame: function requestAnimationFrame(e) {
    return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame: function cancelAnimationFrame(e) {
    "undefined" != typeof setTimeout && clearTimeout(e);
  }
};
function getWindow() {
  var e = "undefined" != typeof window ? window : {};
  return extend(e, ssrWindow), e;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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